import React from 'react'
import { Labeled, NumberFieldProps, NumberField } from 'react-admin'

type Props = Omit<NumberFieldProps, 'label'> & {
  label: string
}

const LabeledNumberField: React.FC<Props> = ({ label, ...rest }) => {
  return (
    <Labeled label={label} sx={{ marginBottom: '16px' }}>
      <NumberField {...rest} />
    </Labeled>
  )
}

export default LabeledNumberField
